<template>
  <config-base ref="configBase" show-plan-details class="opc-zclips" @view-details="handleViewDetails" @expand-change="handleExpandChange" :config-plan-tile-status="configPlanTileStatus">
    <template #rightCornerContent>
      <!-- Teleport target container -->
      <TeleportTarget
        :id="planQuantityTeleportId"
        :visible="showCustomCollapseContent"
        ref="teleportTarget"
      />
    </template>
    <template #topAlert>
    <div v-if="alertMsg">
      <zm-banner show-close class="opc-zclips-top__alert" type="info">
          <span class="opc-zclips-top__alert-msg" v-html="alertMsg" />
      </zm-banner>
    </div>
    </template>
    <template #config>
    <div class="opc-zclips__config">
      <p class="opc-zclips__input-desc">
        {{ $t('billing.zone.select_license') }}
      </p>
      <input-number-with-popover class="opc-zclips__quantity-selector" v-model="selectedNumber" size="lg"
        controls-position="both" :min="minHosts" :max="maxHosts" @change="changeLicense" :decrease-tips="decreaseTips"
        :label="trackingPlanName + ' Select the number of users'"
        :teleport-target="planQuantityTeleportTarget"
        :data-testid="`checkout-input-license-${selectedPlan ? selectedPlan.plan_code : ''}`"
      />
        <license-tip ref="licenseTip" class="mgb-sm" type="zclips" :number="selectedNumber" :additional-spans="additionalSpans">
        </license-tip>
        <zm-banner show-close v-if="mx_downSellLicenseErrorMessage" class="additional-template__alert" type="info">
          <span v-html="mx_downSellLicenseErrorMessage" />
        </zm-banner>
      <config-cycle v-model="billingCycle" :billing-cycle-list="billingCycleList" :showMonthlyPriceFromCycle="true"
        @switchCycleAction="switchCycleAction" :show-cycle-alert="showCycleAlert" :unit="0" />
      <div v-if="showSwitchToMeeting" class="opc-zclips__switch-notice">
        <span>
          {{$t('billing.custom_avatars.switch_to_meeting_notice', [getFreeUserMeetingMinutes()])}}
        </span>
        <zm-button @click="handleSwitchToMeeting" type="link">{{$t('billing.custom_avatars.switch_to_meeting_btn')}}</zm-button>
      </div>
      <preview-payment class="opc-zclips__preview-payment" />
    </div>
    </template>
    <template #footer v-if="canRmv">
      <zm-button data-testid="checkout-button-124" type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + trackingPlanName + ' plan'">
        {{ $t('billing.common.remove') }}
      </zm-button>
    </template>
  </config-base>
</template>

<script type="text/jsx" lang="jsx">
import { mapActions, mapGetters, mapMutations } from 'vuex';
import plansMixin from '@/plans/mx/plan';
import ConfigBase from '@/components/config-base';
import commonMixin from '@/plans/ZOOM_CLIPS/mixin';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import { planTypes } from '@/common/constants';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';
import { plansof } from '@/utils/chain';
import ConfigCycle from '@/components/service/config-billing-cycle/index';
import LicenseTip from '@/plans/ZOOM_MEETING/license-tip.vue';

import AddonMixin from '@/plans/mx/addon';
import _ from "lodash"
import qs from "qs";
import mxPlanDetails from '../dialog/mx-plan-details';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { getFreeUserMeetingMinutes } from '../../../utils/meeting';
import teleportTargetMixin from '@/components/teleport-target/mixin';

const ConfigBaseComp = {
  name: 'ZoomClipsBaseComp',
  extends: ConfigBase,
  mixins: [commonMixin],
  key: planTypes[planTypes.ZOOM_CLIPS],
  props: {
    showPlanDetails: Boolean
  },
  data() {
    return {
      showLearnMore: false,
    };
  },
};

export default {
  name: "ZoomClipsPlusBase",
  mixins: [plansMixin, commonMixin, AddonMixin, mxPlanDetails, teleportTargetMixin],
  components: {
    PreviewPayment,
    ConfigCycle,
    InputNumberWithPopover,
    ConfigBase: ConfigBaseComp,
    LicenseTip,
  },
  data() {
    return {
      selectedNumber: 1,
      billingCycle: '',
      trackingPlanName: getTrackingProductNameByPlanType(planTypes.ZOOM_CLIPS),
      showCycleAlert: true,
      isExpanded: true, // Sync with ConfigBase isExpanded
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlansMap', 'getSelectedPlans', 'planMapFlat', 'getUserCurrentSubscriptions', 'getCurrentBasePlanInfo', 'getTypeGroupSelectedPlans', 'boughtPlans']),
    planList() {
      return plansof(this.planMapFlat).type(this.planType).get();
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
    minHosts() {
      return 1;
    },
    maxHosts() {
      return 99;
    },
    decreaseTips() {
      return '';
    },
    disabledForBulkLicense() {
      return () => false;
    },
    disabledForBulkLicenseTips() {
      return this.$t('billing.error.buld_acount_license');
    },
    canRmv() {
      return false;
    },
    additionalSpans() {
      return {
        zclips: [
          {
            value: 1,
            text: '',
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_plans', [99, 100]),
          },
        ]
      }
    },
    alertMsg() {
      return "";
    },
    showSwitchToMeeting () {
      return false;
    },
    depCurrentAllAddonCyclePlanList() {
      return this.getUserCurrentSubscriptions?.filter(p => p?.billingCycleDependBasePlanTypeList?.includes(this.planType)) ?? [];
    },

    depAddonMaxCyclePlan() {
      return  _.chain(this.depCurrentAllAddonCyclePlanList)
          .filter(p => !p.cancelled)
          .orderBy((p) => p.cycleValue, 'desc')
          .get(0)
          .value();
    },
    /** soft bundle custom collapse content start */
    showCustomCollapseContent() {
      return this.soft_bundle_showCustomCollapseContent && !this.isExpanded;
    },
    /** soft bundle custom collapse content end */
  },
  methods: {
    getFreeUserMeetingMinutes,
    ...mapMutations(['updateSelectPlan']),
    ...mapActions(['switchBillingCycleAction']),
    changeLicense(newLicense) {
      this.selectedNumber = newLicense;
      this.updateSelectPlan({
        plan_code: this.selectedPlan?.plan_code,
        cartInfo: { selected_number: newLicense },
      });
      this.mx_validDownSellLicense(newLicense)

      if (newLicense === this.maxHosts) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - the maximum amount is ${this.maxHosts} licenses - impression`,
        );
      }
    },
    async switchCycleAction(oldPlan, newPlan) {
      // when the current license less than max, get current license, otherwise get maxHosts
      const quantity = this.selectedNumber <= this.maxHosts ? this.selectedNumber : this.maxHosts;
      const newPlanInfo = { ...newPlan, cartInfo: { selected_number: quantity } };

      await this.switchBillingCycleAction([
        oldPlan?.plan_code,
        newPlanInfo,
      ]);

      // event tracking
      const billingCycle = this.selectedPlan?.billing_cycle;
      billingCycle && this.$tracking.addOnBuyInteraction(
        `${this.trackingPlanName} billing cycle`,
        this.$tEn(`billing.billing_cycle.${billingCycle}`)?.toLowerCase(),
      );
    },
    async handleViewDetails() {
      await this.showPlanDetailDialog();
    },

    handleSwitchToMeeting () {
      // use universal link, basic2Pro or buyNow flow
      const customAvatarsWithClipsLink = "/buy";
      const searchQueryParams = {
        plan: "pro",
        period: "monthly",
        product: "CUSTOMAVATARS",
        usageType: "business"
      }
      const finalLink = `${customAvatarsWithClipsLink}?${qs.stringify(searchQueryParams)}`;
      // window.location.href = finalLink;
      location.replace(finalLink);
    },
    handleExpandChange(isExpanded) {
      this.isExpanded = isExpanded;
    },
  },
  created() {
    const selectedPlan = this.selectedPlan;

    if (selectedPlan) {
      this.billingCycle = selectedPlan.billing_cycle;
      this.selectedNumber = selectedPlan.cartInfo?.selected_number;

      // refresh page
      this.$nextTick(() => {
        this.mx_validDownSellLicense(this.selectedNumber);
      });
    }
  },
  mounted() {
    this.$refs?.licenseTip?.$el?.addEventListener('click', (e) => {
      if (e?.target?.tagName === 'A') {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - the maximum amount is ${this.maxHosts} licenses - contact sales`,
        );
      }
    });
  },
  watch: {
    selectedNumber: {
      handler(newLicense, oldLicense) {
        this.$tracking.buyInteraction(
          `number of licenses`,
          `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`,
        );
      },
    },
  },
};
</script>

<style lang="scss">
.opc-zclips {
  &__input-desc {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &__quantity-selector {
  }

  .opc-zclips-top__alert {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;
    border-radius: 8px;
    margin-bottom: 24px;

    .zbo-banner__body {
      padding: 0;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 150%;
      strong {
        font-weight: bold;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      }
    }
  }

  &__preview-payment {
    margin-top: 24px;
  }

  &__switch-notice {
    margin-top: 24px;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }
}
</style>
